import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=1db40e9e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=1db40e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db40e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db40e9e')) {
      api.createRecord('1db40e9e', component.options)
    } else {
      api.reload('1db40e9e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=1db40e9e&scoped=true&", function () {
      api.rerender('1db40e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dw0iCB8iJy7y/JS/comp/CookieBox.vue"
export default component.exports